import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from './icons/Icons';
import { useLanguage } from '../data/i18n';
import { HOURS_IMAGE_URL } from '../data/site';
export function Hours() {
  const {
    t
  } = useLanguage();
  return <section id="horario" className="relative w-full bg-black py-24 sm:py-32 overflow-hidden" data-id="element-81" data-mp="13434yvdgzq8j">
      <div className="absolute inset-0" data-id="element-82" data-mp="181v8kmnh90sk">
        <img src={HOURS_IMAGE_URL} alt="" aria-hidden="true" className="h-full w-full object-cover grayscale contrast-125 opacity-30" data-id="element-83" data-mp="t6f9g381iepb" />
        <div className="absolute inset-0 bg-black/70" data-id="element-84" data-mp="y2vyr0qz6z3z" />
      </div>

      <div className="relative z-10 mx-auto max-w-3xl px-6" data-id="element-85" data-mp="k71zl9g07o42">
        <div className="flex items-center justify-center gap-3" data-id="element-86" data-mp="p424vi514mu4">
          <ClockIcon className="w-5 h-5 text-white/60" data-id="element-87" data-mp="p6eumhh141hq" />
          <p className="font-sans text-[10px] uppercase tracking-[0.4em] text-ash" data-id="element-88" data-mp="2ekthew8hleal">{t.hours.eyebrow}</p>
        </div>

        <h2 className="mt-5 text-center font-display text-5xl sm:text-6xl tracking-[0.05em] text-bone" data-id="element-89" data-mp="2jhtnh75c6h1p">
          {t.hours.title}
        </h2>

        <dl className="mt-14 divide-y divide-white/10 border-y border-white/10" data-id="element-90" data-mp="2y8jrhvnz0srn">
          {t.hours.rows.map((row, i) => {
          const closed = i === t.hours.rows.length - 1;
          return <motion.div key={row.day} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.08
          }} className="flex flex-col gap-1 py-6 sm:flex-row sm:items-baseline sm:justify-between" data-id="element-91" data-mp="3703nwb54yqjg" data-mpi={i}>
                <dt className="font-display text-2xl tracking-[0.12em] text-bone" data-id="element-92" data-mp="2o9kvpdob0rm2">{row.day}</dt>
                <dd className={`font-body text-sm sm:text-base font-light tracking-wide ${closed ? 'text-white/35' : 'text-white/70'}`} data-id="element-93" data-mp="8iq18717v2fl">
                  {row.time}
                </dd>
              </motion.div>;
        })}
        </dl>
      </div>
    </section>;
}